<template>
  <div>
    <b-tabs
      pills
      fill
    >
      <b-tab active>
        <template #title>
          <feather-icon icon="FileTextIcon" />
          <span>Proforma Fatura Bilgileri</span>
        </template>
        <validation-observer ref="simpleRules">
          <proforma-form
            :submit-form="submitForm"
            :submit-status="submitStatus"
            :remove-item="removeItem"
            :add-items="getProductList"
          />
        </validation-observer>
      </b-tab>
      <b-tab lazy>
        <template #title>
          <feather-icon icon="UserIcon" />
          <span>Müşteri Bilgileri</span>
        </template>
        <customer-info />
        <customer-invoice />
      </b-tab>
      <b-tab lazy>
        <template #title>
          <feather-icon icon="ClockIcon" />
          <span>Müşteri Geçmişi</span>
        </template>
        <customer-history :customer-id="this.$route.params.id_customers" />
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import {
  BTabs, BTab,
} from 'bootstrap-vue'
import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ProformaForm from '@/views/Admin/Proforma_invoices/ProformaForm.vue'
import CustomerInfo from '@/views/Admin/Customers/View/CustomerInfo.vue'
import CustomerInvoice from '@/views/Admin/Customers/View/CustomerInvoice.vue'
import CustomerHistory from '@/views/Admin/Customers/View/CustomerHistory.vue'
// eslint-disable-next-line import/extensions
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  name: 'Edit',
  components: {
    BTabs,
    BTab,
    ProformaForm,
    CustomerInfo,
    CustomerInvoice,
    CustomerHistory,
    ValidationObserver,
  },
  data() {
    return {
      required,
      submitStatus: false,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['proformaInvoices/dataItem']
    },
    saveData() {
      return this.$store.getters['proformaInvoices/dataSaveStatus']
    },
    dataList() {
      return this.$store.getters['proformaInvoices/productList']
    },
    offerData() {
      return this.$store.getters['offerLines/dataList']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.$router.push(`/app/proforma-invoices/view/${val.id}`)
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
    },
  },
  created() {
    this.$store.commit('proformaInvoices/RESET_DATA_ITEM')
    this.$store.commit('proformaInvoices/RESET_PRODUCT_DATA')
    this.getData()
    localize('tr')
  },
  methods: {
    getData() {
      this.$store.dispatch('proformaInvoices/getDataItem', { id: this.$route.params.id, isUpdate: true })
        .then(response => {
          if (response) {
            this.getCustomer(response.id_customers)
            this.getCustomerRelatedPerson(response.id_customers)
            this.getCurrency(response.id_currencies)
            this.getLinesData(response.id, response.id_offers)
          }
        })
    },

    getCustomer(index) {
      this.$store.dispatch('customers/getDataItem', index)
    },
    getCustomerRelatedPerson(index) {
      this.$store.dispatch('customerRelatedPersons/getDataList', {
        where: {
          'customer_related_persons.id_customers': index,
        },
      })
    },
    getLinesData(proforma, offers) {
      this.$store.dispatch('proformaInvoices/getProductList', {
        id_proforma_invoices: proforma,
        id_offers: offers,
      })
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          // this.submitStatus = true
          let processError = false
          this.dataItem.proforma_lines = []
          for (let i = 0; i < this.dataList.length; i += 1) {
            for (let l = 0; l < this.dataList[i].productList.length; l += 1) {
              if (!this.dataList[i].productList[l].id_units) {
                this.showToast({
                  variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: 'Lütfen "Birim" alanlarını doldurduğunuzdan emin olun.',
                })
                processError = true
                break
              }
              this.dataItem.proforma_lines.push(this.dataList[i].productList[l])
            }
          }
          if (!processError) {
            this.$store.dispatch('proformaInvoices/saveData', this.dataItem)
          }
        }
      })
    },
    removeItem(id, productType = null, index = null) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('proformaInvoices/removeLine', this.dataList[productType].productList[index].id)
          this.dataList[productType].productList.splice(index, 1)
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
          // this.getLinesData(this.dataItem.id, this.dataItem.id_offers)
        }
      })
    },
    getProductList() {
      this.$store.dispatch('proformaInvoices/getProductList', {
        id_proforma_invoices: this.dataItem.id,
        id_offers: this.dataItem.id_offers,
      })
    },
    getCurrency(index) {
      this.$store.dispatch('currencies/getDataItem', index)
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
